import React, {useState} from "react";
import {useDispatch} from "react-redux";
import { setMessage } from "../../Redux/Actions";
import '../Message/Message.css';


export default function Message ({content, state}) {

    const dispatch = useDispatch();
    
    function AceptMessage() {
        dispatch(setMessage({}));
    }
    
    return (
        <div className={(state) ? 'container-message-active' : 'container-message-inactive'}>
            <div className="content-message">
            <p className="icon-message">!</p>
                <h1 className="title-message">Advertencia</h1>
                <h2 className="message">{content}</h2>
                <button className="button-message" onClick={AceptMessage}>SALIR</button>
            </div>
        </div>
    );
}